import { ActiveRecord, sources } from '@mysidewalk/active-record';
import { DataReference } from '../data/index.js';
import ColumnDataType from './ColumnDataType.js';
/**
 * @memberof customer-metadata
 * @property {number} id
 * @property {customer-metadata.ColumnDataType} dataType
 * @property {customer-metadata.ColumnMapping} columnMapping
 * @property {string} fieldName
 * @property {customer-metadata.UserLayer} userLayer
 */
class Column extends ActiveRecord {
    get characteristicType() {
        return this.columnMapping && this.columnMapping.userCharacteristicType;
    }
    get timeElement() {
        return this.columnMapping && this.columnMapping.timeElement;
    }
    get isProjection() {
        return false;
    }
    getDefaultNormalizers() {
        return Promise.resolve([]);
    }
    /**
     * @return {data-references.DataReference}
     */
    toDataReference() {
        return new DataReference({
            type: DataReference.SourceType.SYSTEM,
            sourceId: this.userLayer.id,
            column: this.id,
        });
    }
    static forFieldName(layerId, fieldName) {
        return new Promise((resolve, reject) => {
            forFieldNameConsolidated(layerId, fieldName, { resolve, reject });
        });
    }
    static forReference(dataReference) {
        return Column.forFieldName(dataReference.sourceId, String(dataReference.column));
    }
}
Column.DataType = ColumnDataType;
Column.dataTypeFriendlyNames = {
    [ColumnDataType.STRING]: 'text',
    [ColumnDataType.DATE]: 'date',
    [ColumnDataType.BOOLEAN]: 'boolean',
    [ColumnDataType.INTEGER]: 'number',
    [ColumnDataType.FLOAT]: 'number',
};
Column.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
};
const DEFAULT_INCLUDE = [
    'column_mapping.user_characteristic_type',
    'column_mapping.time_element',
].join(',');
let next = [];
let timer = null;
function makeConsolidatedRequests() {
    const processing = [...next];
    // Organize requests by user layer id
    const fieldsByLayerId = next.reduce((memo, { layerId, fieldName }) => {
        memo[layerId] = memo[layerId] || [];
        memo[layerId].push(fieldName);
        return memo;
    }, {});
    next = [];
    timer = null;
    // Issue a single request for the list of field names per user layer
    const requests = Object.keys(fieldsByLayerId).map(layerId => (Column.all({
        include: DEFAULT_INCLUDE,
        fieldNames: fieldsByLayerId[layerId],
        userLayer: layerId,
    })));
    // Resolve the promise for each "request" after finding the matching result
    return Promise.all(requests)
        .then((resultsByLayer) => {
        const results = resultsByLayer.flat();
        processing.forEach(({ layerId, fieldName, deferral }) => {
            const match = results.find((c) => c.userLayer.id === layerId && c.fieldName === fieldName);
            deferral.resolve(match);
        });
    });
}
const MAX_REQUEST_BUNDLE = 20; // Pairing of fieldName & layerId
const MAX_DELAY = 50; // milliseconds
function forFieldNameConsolidated(layerId, fieldName, deferral) {
    // Add request to list to be processed
    next.push({ layerId, fieldName, deferral });
    timer && clearTimeout(timer);
    // Beacuse of limitations of URI length (HTTP Error 414), set max count
    if (next.length >= MAX_REQUEST_BUNDLE) {
        makeConsolidatedRequests();
    }
    else {
        // Wait 50 miliseconds for any additional "requests", then make API call
        timer = setTimeout(makeConsolidatedRequests, MAX_DELAY);
    }
}
export default Column;
